import React, { Fragment } from 'react'
import style from './style.css'
import classNames from 'classnames'

import Button from '../button/Button'

export default class Table extends React.Component {
  getArray = (data) => {
    if (data && Array.isArray(data)) {
      return data
    } else if (data) {
      return [data]
    } else {
      return []
    }
  }

  // Helper function to extract text content from React nodes
  extractText = (node) => {
    if (typeof node === 'string') return node.trim()
    if (Array.isArray(node)) return node.map(this.extractText).join(' ')
    if (node && node.props && node.props.children)
      return this.extractText(node.props.children)
    return ''
  }

  getCSV = (callback) => {
    let dataCSV = ''

    console.log('this.props', this.props)
    if (this.props && this.props.children) {
      console.log('this.props.children', this.props.children)
      const tableChildren = this.getArray(this.props.children)

      // Trouver tous les Tr dans toute la table (pas seulement Thead/Tbody)
      const allRows = tableChildren.flatMap((section) =>
        this.getArray(section.props?.children).filter(
          (child) =>
            child?.type?.name === 'Tr' ||
            child?.type?.displayName === 'Tr' ||
            child?.type?.displayName === 'tr'
        )
      )

      console.log('Toutes les lignes (Tr) trouvées:', allRows)

      if (allRows.length > 0) {
        allRows.forEach((row, rowIndex) => {
          console.log(
            row.props.children.length,
            row.props.children.length !== 2,
            row.props.children.type,
            row.props.children.type === React.Fragment,
            row
          )
          const cells = this.getArray(
            row.props.children.length !== 2
              ? row.props.children.type === React.Fragment
                ? row.props.children.props.children[0]
                : row.props.children
              : row.props.children[0]
          ).filter(
            (cell) =>
              cell?.type?.name === 'Th' ||
              cell?.type?.name === 'Td' ||
              cell?.type?.displayName === 'Th' ||
              cell?.type?.displayName === 'Td' ||
              cell?.type?.displayName === 'th' ||
              cell?.type?.displayName === 'td'
          )

          const rowData = cells
            .map((cell) =>
              cell.props && cell.props.children
                ? this.extractText(cell.props.children)
                : ''
            )
            .join(';')

          dataCSV += rowData + '\n'
        })
      }
    }

    console.log('CSV output:', dataCSV)

    if (dataCSV) {
      const link = document.createElement('a')
      link.href = `data:text/csv;charset=utf-8,\uFEFF${encodeURIComponent(
        dataCSV
      )}`
      link.download = this.props.nameCSV || 'file.csv'
      link.click()
    } else {
      console.warn('Le CSV est vide, vérifiez la structure du tableau.')
    }

    callback()
  }

  render() {
    const tableClass = classNames({
      [style.table]: true,
      [style.tableEmpty]: !!this.props.empty,
      [style.radiusTopLeft]: !!this.props.radiusTopLeft,
      [style.radiusTopRight]: !!this.props.radiusTopRight,
      [this.props.className]: !!this.props.className
    })

    return (
      <Fragment>
        {this.props.isCSV ? (
          <div className='d-flex'>
            <Button
              text='Télécharger CSV'
              className='w-auto ml-auto mb-10'
              onClick={() => {
                if (this.props.getAllData) {
                  this.props.getAllData(() =>
                    this.getCSV(this.props.csvCallback)
                  )
                } else {
                  this.getCSV(this.props.csvCallback)
                }
              }}
            />
          </div>
        ) : null}
        <table className={tableClass} style={this.props.style}>
          {this.props.children}
          {this.props.empty ? (
            <tbody>
              <tr>
                <td colSpan='100'>
                  <div className={style.trEmpty}>{this.props.empty}</div>
                </td>
              </tr>
            </tbody>
          ) : (
            false
          )}
        </table>
      </Fragment>
    )
  }
}
